import { DOMAIN } from "../../../../../var_env."
import { RequestResponsePattern } from "../../../../../types/Request"
import { setLista, setRequestGetData, setRequestGetError, setRequestGetLoading, setRequestGetMessage } from "../Reducers/RamoAtividadeReducer"
import { getApi } from "../../../../../utils/requestApi"
import { RamoAtividadeType } from "../Types/RamoAtividadeType"

export default async function getRamoAtividade(dispatch: Function){
    try {
        dispatch(setRequestGetLoading())

        const endpoint = DOMAIN
        const params = `/RamoAtividade`
        const response: RequestResponsePattern<RamoAtividadeType[]> = await getApi({ endpoint, params })
        
        if(response){
            dispatch(setRequestGetData(response))
            if(!response.flagErro) {
                dispatch(setLista(response.listaResultados))
                localStorage.setItem('ramoAtividade', JSON.stringify(response.listaResultados))
            } else throw new Error(response.listaMensagens[0])
        }else throw new Error('Erro na requisição')
    } catch (error: any) {
        console.log(error)
        dispatch(setRequestGetMessage(error.message ?? JSON.stringify(error)))
        dispatch(setRequestGetError())
    }
}